/*****************************************************************
 ** Copyright (c) 帕加马直播预览
 ** 创建人:      Eugene
 ** 创建日期:    2020/10/10
 ** 修改人:
 ** 修改日期:
 ** 描 述: 全局只读配置
 **-----------------------------------------------------------------
 ******************************************************************/

import request from '@/utils/$x';

// 查询直播内容库信息列表
export async function getLiveClassList(params) {
  return request.http('/livePlay/getLivePlaybackInfoForAdmin', {
    method: 'post',
    data: params,
  });
}

// 查看直播内容详情
export async function getLiveClassInfo(params) {
  return request.http('/livePlay/getLivePlaybackDetailsByIdForAdmin', {
    method: 'post',
    data: params,
  });
}

// 直播运营库替换回放链接
export async function updatePlaybackUrl(params) {
  return request.http('/livePlay/updatePlaybackUrl', {
    method: 'post',
    data: params,
  });
}

// 存量课程补充渠道
export async function bindLiveChannelAndSupplementData(params) {
  return request.http('/livePlay/bindLiveChannelAndSupplementData', {
    method: 'post',
    data: params,
  });
}
